import script from "./RegisterOrderBusinessModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./RegisterOrderBusinessModal.vue?vue&type=script&setup=true&lang=ts"

import "./RegisterOrderBusinessModal.vue?vue&type=style&index=0&id=09ef9486&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09ef9486"]])

export default __exports__